import React, { ReactNode } from 'react';
import cx from 'classnames';

interface BackgroundContainerProps {
  children: ReactNode;
  withHeroChild?: boolean;
}

export function BackgroundContainer({
  children,
  withHeroChild = false
}: BackgroundContainerProps) {
  return (
    <div data-testid="background-cover-container" className="h-full">
      <div
        className={cx(
          'dekstop:p-0 flex h-full items-center p-3 desktop:items-center',
          withHeroChild &&
            'p-0 desktop:px-0 desktop:pb-[2.8125rem] desktop:pt-[1.875rem]'
        )}
      >
        <div className="container" data-testid="background-cover-hero-block">
          {children}
        </div>
      </div>
    </div>
  );
}
